import { newToolFilterOAuthMcp } from "../oauth.ts";

export const synapseMcpResolver = newToolFilterOAuthMcp({
  iconUrl: "https://www.synapse.org/favicon.png",
  url: "https://mcp.synapse.org/mcp",
  label: "Synapse",
});
